var _defs, _text, _line, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilligram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "200px",
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#F5DC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#D4AE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A7400"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 100,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 96,
    fontWeight: "bold",
    fontStyle: "italic",
    fill: "url(#goldGrad)",
    letterSpacing: 3
  }, "Milligram")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 130,
    x2: 720,
    y2: 130,
    stroke: "#B89010",
    strokeWidth: 1.2,
    opacity: 0.7
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 165,
    textAnchor: "middle",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 22,
    fontStyle: "italic",
    fill: "#9A7400",
    letterSpacing: 5
  }, "Trade Gold. Anytime.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilligram);
export default __webpack_public_path__ + "static/media/milligram.104a5cc2c8277434e21efe8cbb1f7e29.svg";
export { ForwardRef as ReactComponent };